import React, {useEffect, useState} from 'react'
import {StyledMobileMenuICons, StyledContainerMobileMenu} from './style'
import {NavBottom} from "../../theme/theme";
import BadgeCounter from '../../components/BadgeCounter'
import {useHistory, useLocation, useRouteMatch} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/reducers";
import config from "../../config/enviroment";
import { language } from '../../utils/language';
import { captureCartReturnPath } from '../../utils/cartReturnPath';


const MobileNavBotton = ()=>{
    const homeState: HomeStateType = useSelector((state: RootState) => state.home)
    const shoppingCartState: ShoppingCartStateType = useSelector((state: RootState) => state.shoppingCart)
    const history = useHistory()
    const location = useLocation()

    const match:any = useRouteMatch('/vende/:idCatalog')
    const basePath = `/vende/${match?.params.idCatalog}`

    const initialState = {
        "categories":false,
        "home":false,
        "shoppingcart":false
    }
    const [pageSelected,setPageSelected] = useState(initialState)


    const handleCalcProducts = () => {
		let contador = 0;

		shoppingCartState.cartInfo.map((item: any) => {
			if (item.references && item.references.length > 0) {

				item.references.map((ref:any)=>{
					contador += ref.quantity;

				});
			} else {
				contador+=item.quantity;
			}
		});
		return contador;
	};


    useEffect(()=>{
        
        let newPageSelected = {
            "categories":false,
            "home":false,
            "shoppingcart":false
        }

        switch (location.pathname) {
            case `${basePath}/categories`:
                newPageSelected.categories = true
                break;
            case `${basePath}/`:
                newPageSelected.home = true    
                break;

            case `${basePath}/carrito/${shoppingCartState.id}`:
                newPageSelected.shoppingcart = true    
                break;

            case `${basePath}/carrito/empty`:
                newPageSelected.shoppingcart = true    
                break;
        
            default:
                newPageSelected = initialState
                break;
        }


        setPageSelected(newPageSelected)

    },[location.pathname])

    return (
        <NavBottom>
            <StyledContainerMobileMenu>
                <StyledMobileMenuICons
                    onClick={()=>history.push(`${basePath}/`)}
                    color={homeState.color}
                    isSelected={pageSelected.home}>
                    <svg data-src={`${config.urlMultimedia}/vende/landing-img/HomeIcon.svg`}/>
                    <span>{language[homeState.default_language]["home"]}</span>
                </StyledMobileMenuICons>
                <StyledMobileMenuICons
                    onClick={()=>history.push(`${basePath}/categories`)}
                    isSelected={pageSelected.categories}
                    color ={homeState.color}>
                    <svg data-src={`${config.urlMultimedia}/vende/landing-img/CategoryIcon.svg`}/>
                    <span>{language[homeState.default_language]["category"]}</span>
                </StyledMobileMenuICons >
                <StyledMobileMenuICons
                    onClick={() => history.push(
                        shoppingCartState.cartInfo.length > 0 ?
                            `${basePath}/carrito/${shoppingCartState.id}`
                        :
                            `${basePath}/carrito/empty`
                        ,
                        { from: captureCartReturnPath() }
                        )}
                    color ={homeState.color}
                    isSelected={pageSelected.shoppingcart}>
                    <svg data-src={`${config.urlMultimedia}/vende/landing-img/CartIcon.svg`}/>
                    {
                        shoppingCartState.cartInfo.length > 0 &&

                            <BadgeCounter color={homeState.color} 
                                        totalCartProducts={handleCalcProducts()}
                                        isSelected={pageSelected.shoppingcart}
                                        isFooter={true}
                            />
                    }
                    <span>{language[homeState.default_language]["cart"]}</span>
                </StyledMobileMenuICons>
            </StyledContainerMobileMenu>
        </NavBottom>
    )
}

export default MobileNavBotton
